import React, { useState } from 'react';
import './Contact.css';
import Header from '../componets/header/header';
import Footer from '../componets/footer/footer';
import { Button, Form, Input, notification } from 'antd';
import { API } from '../../config/api';
import { POST } from '../../utils/apicalls';

const Contact = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                visitorsId: values.visitorsId,
                type: "visitor",
                visitors_name: values.visitors_name,
                date: values.date || new Date().toISOString(),
                visitors_email: values.visitors_email,
                visitors_purpose: "from website",
                employee_id: 1,
                visitors_phone: values.visitors_phone,
                description: values.description,
                altPhone: values.altPhone,
            };

            setIsLoading(true);
            const api = API.CREATE_VISITORS;
            const postRequest: any = await POST(api, obj);
            if (postRequest.status) {
                notification.success({ message: "visitors created successfully!" });
                setIsLoading(false);
                setIsModalOpen(false);
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="contact-page">
            <Header />
            <div className="contact-container" style={{ marginTop: "90px" }}>
                <div className="contact-left">
                    <p className="highlight-text">CONTACT WITH US</p>
                    <h1>LET’S WORK TOGETHER?</h1>
                    <p className="description">
                        Sed ut perspiciatis unde omnis natus error sit voluptatem accusantium doloremque laudantium totam rem.
                    </p>
                    <div className="contact-info">
                        <div className="info-box">
                            <div className="icon">📞</div>
                            <div>
                                <p className="info-title">HAVE ANY QUESTION?</p>
                                <p>Free <a href='tel:+919562121008' style={{ textDecoration: "none", color: "black" }}>+91 956 2121 008</a></p>
                            </div>
                        </div>
                        <div className="info-box">
                            <div className="icon">✉️</div>
                            <div>
                                <p className="info-title">SEND EMAIL</p>
                                <a style={{ textDecoration: "none", color: "black" }} href='mailto:admin@papadigitalacademy.com'>admin@papadigitalacademy.com</a>

                            </div>
                        </div>
                        <div className="info-box">
                            <div className="icon">📍</div>
                            <div>
                                <p className="info-title">VISIT ANYTIME</p>
                                <p> Kuzhikkattumoola, Kakkanad, Kochi, Kerala</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contact-right">
                    <h2>CONTACT US</h2>
                    <Form
                        form={form}
                        name="contact_form"
                        onFinish={submitHandler}
                        layout="vertical"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                        <Form.Item
                            name="visitors_name"
                            label="Your Name"
                            rules={[{ required: true, message: "Please enter your name" }]}
                        >
                            <Input placeholder="Your Name" />
                        </Form.Item>

                        <Form.Item
                            name="visitors_email"
                            label="Email Address"
                            rules={[{ required: true, type: "email", message: "Enter valid email" }]}
                        >
                            <Input placeholder="Email Address" />
                        </Form.Item>

                        <Form.Item
                            name="visitors_phone"
                            label="Phone Number"
                            rules={[{ required: true, message: "Please enter your phone number" }]}
                        >
                            <Input placeholder="Phone Number" />
                        </Form.Item>

                        <Form.Item
                            name="altPhone"
                            label="Subject"
                            rules={[{ required: true, message: "Please enter the subject" }]}
                        >
                            <Input placeholder="Subject" />
                        </Form.Item>

                        <Form.Item
                            name="description"
                            label="Comment"
                            rules={[{ required: true, message: "Please enter your comment" }]}
                        >
                            <Input.TextArea placeholder="Comment" rows={4} />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isLoading}>
                                WRITE A MESSAGE
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="contact-map">
                <iframe
                    title="Papa Digital Solution Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.0522063904414!2d76.35704489999999!3d10.0125466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080b8e438fd2d7%3A0xc2fd89aac43145b4!2sPapa%20Digital%20Solution!5e0!3m2!1sen!2sin!4v1749726685226!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />

            </div>

            <Footer />
        </div>

    );
};

export default Contact;
